import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TextListComponent} from './text-list.component';
import {EvaButtonModule} from '../eva-button/eva-button.module';
import {MediaPictureModule} from '@shopping-angular-components/media-picture';
import {TextModule} from '../text/text.module';


@NgModule({
    declarations: [TextListComponent],
    exports: [
        TextListComponent
    ],
    imports: [
        CommonModule,
        EvaButtonModule,
        MediaPictureModule,
        TextModule
    ]
})
export class TextListModule { }
